<div class="register">
    <div class="body">
        <div class="form-input checkbox">
            <input (change)="onChangeAcceptRisks()" type="checkbox" id="cb1">
            <label for="cb1">{{ 'register.lw_conditions.check' | translate }}</label>
        </div>
    </div>
</div>